import Image from 'next/image';
import { useTranslation } from 'next-i18next';

interface HelpCenterContactFooterProps {
  className?: string;
}

const HelpCenterContactFooter = ({ className = '' }: HelpCenterContactFooterProps) => {
  const { t } = useTranslation('common');

  return (
    <div
      className={`bg-gray-50 border border-gray-200 rounded-lg p-4 md:p-6 flex flex-col md:flex-row items-center md:items-start ${className}`}
    >
      <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-6">
        <Image
          src="/images/help/email.webp"
          alt="Contact us"
          width={90}
          height={90}
          className="w-[90px] h-[90px] md:w-[120px] md:h-[120px]"
        />
      </div>
      <div className="flex-grow text-center md:text-left">
        <h2 className="text-lg md:text-xl font-semibold mb-2">{t("Can't find your answer?")}</h2>
        <h3 className="text-sm md:text-base text-gray-600 mb-3">
          {t('We want to answer all of your queries.')}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSe3aljcy3RKOo29b9NPdRnDUK6jNfxZ1fYxwN7T5XmNH1_iTQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#725CFF] font-medium ml-1"
          >
            {t('Click here')}
          </a>
          {t(' to submit your feedback, and we will contact you as soon as possible.')}
        </h3>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSe3aljcy3RKOo29b9NPdRnDUK6jNfxZ1fYxwN7T5XmNH1_iTQ/viewform"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#725CFF] font-medium flex items-center justify-center md:justify-start mx-auto md:mx-0"
        >
          {t('Click here')}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="ml-1"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default HelpCenterContactFooter;
